import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverFormMutations: UpdatesConfig['Mutation'] = {
  waiverFormCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverForms', cache);
  },
  waiverFormUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverForms', 'waiverForm'], cache);
  },
  waiverFormStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverForms', 'waiverForm'], cache);
  },
};

export default waiverFormMutations;
